export const company = {
  name: 'DSTRCT Group',
  email: 'hello@dstrctgroup.com',
  phone: '(+31) 6 155 85 214',
  phoneHref: '+31615585214',
  address: 'Rendementsweg 24 K, 3641 SL Mijdrecht',
  site: 'dstrctsolutions.nl',
  siteHref: 'https://dstrctsolutions.nl/',
}

export const offer = {
  client: 'Daily Car Care',
  subject: 'Boekingssysteem & website',
  price: '€ 3.000',
  priceNote: 'excl. btw · eenmalig',
  duration: '3 – 4 weken',
  date: '21 september 2026',
  validUntil: '19 oktober 2026',
}

export const demo = {
  site: 'https://dailycc.dstrct.website/',
  admin: 'https://dailycc.dstrct.website/admin',
}

// Screenshots uit de opgeleverde demo-omgeving.
export const shots = {
  site: 'https://cdn.magicpatterns.com/uploads/3Fnam4PczuxVNEVHas24hT/Daily-Car-Care-09-22-2026_01_31_AM.png',
  booking:
    'https://cdn.magicpatterns.com/uploads/q7UJ6rv16RtrN5Nznn5Q9B/Daily-Car-Care-09-22-2026_01_29_AM.png',
  dashboard:
    'https://cdn.magicpatterns.com/uploads/whxB28m2WWEVjPA72dG36A/Daily-Car-Care-09-22-2026_01_29_AM_(1).png',
  agenda:
    'https://cdn.magicpatterns.com/uploads/nnPeRiyt44AacZW16uWqnM/Daily-Car-Care-09-22-2026_01_30_AM.png',
  bookingDetail:
    'https://cdn.magicpatterns.com/uploads/wymDhzuRxcsvMza5iCwH1K/Daily-Car-Care-09-22-2026_01_30_AM_(1).png',
}

export const capabilities = [
  { title: 'Website', text: 'Diensten, prijzen, werk en contact.' },
  { title: 'Boekingsflow', text: 'Behandeling, voertuig, datum en gegevens.' },
  { title: 'Beheeromgeving', text: 'Dashboard, agenda, boekingen en diensten.' },
]

export const bookingSteps = [
  { step: '01', title: 'Behandeling', text: 'Diensten en extra’s met prijs en werkplaatstijd.' },
  { step: '02', title: 'Voertuig', text: 'Merk, model en kenteken.' },
  { step: '03', title: 'Datum & tijd', text: 'Alleen sloten die in de planning vrij zijn.' },
  { step: '04', title: 'Gegevens', text: 'Bevestigen, met aanbetaling en rest na de behandeling.' },
]

export const bookingPoints = [
  'Live prijsopbouw van behandeling en extra’s',
  'Duur per behandeling bepaalt de benodigde tijd in de werkplaats',
  'Aanbetaling online, restbedrag na de behandeling',
  'Bevestigingsmail naar klant en studio',
]

export const adminPoints = [
  'Dashboard: omzet, aanbetalingen, open aanvragen en bezetting',
  'Vandaag in de werkplaats en laatste boekingen op één scherm',
  'Maandagenda met afspraken, omzet en bezetting per dag',
  'Boeking openen met klant, voertuig, extra’s en bedragen',
  'Afspraak verzetten naar andere datum of tijd',
  'Status zetten op aanvraag, bevestigd of geannuleerd',
  'Nieuwe afspraak handmatig inplannen of een dag blokkeren',
  'Diensten, prijzen, duur en instellingen zelf beheren',
]

export const featureGroups = [
  {
    title: 'Website',
    items: ['Home, diensten, ons werk, studio, contact', 'Mobiel en desktop', 'Direct bellen of boeken'],
  },
  {
    title: 'Boeken',
    items: ['Diensten en extra’s met prijs en duur', 'Datum- en tijdslotkeuze', 'Aanbetaling via iDEAL'],
  },
  {
    title: 'Beheer',
    items: ['Dashboard en agenda', 'Boekingen en statussen', 'Diensten en instellingen'],
  },
]

export const excluded = [
  'Fotografie en teksten',
  'Transactiekosten van iDEAL',
  'Functionaliteit buiten deze scope',
]

export const phases = [
  { week: 'Week 1', title: 'Inrichting', text: 'Diensten, prijzen, duur en openingstijden.' },
  { week: 'Week 2', title: 'Website & boeken', text: 'Site en boekingsflow op de echte agenda.' },
  { week: 'Week 3', title: 'Beheeromgeving', text: 'Dashboard, agenda, boekingen en mails.' },
  { week: 'Week 4', title: 'Test & livegang', text: 'Testen, training van 1 uur, live.' },
]

export const included = [
  'Website, boekingsflow en beheeromgeving',
  'Bevestigingsmails naar klant en studio',
  'Domein, hosting-setup en SSL',
  'Training van 1 uur en 14 dagen nazorg',
]
